import React from "react";

import PageRoot from "@refere/ui-utils/ui/components/PageRoot";
import Stepper, { StepperData } from "@refere/ui-utils/ui/components/Stepper";

import AvisoMaisDeDoisSegurosAtivos from "../componentes/AvisoMaisDeDoisSegurosAtivos";
import SummaryBox from "../componentes/SummaryBox";
import PassoSeguro from "./components/PassoSeguro";
import PassoContratacao from "./components/PassoContratacao";

import { useHookstate } from "@hookstate/core";

import { globalState } from "../../features/global-state";
import { gotoPassoSeguro } from "../../features/pages/seguro/passo-seguro";
import { gotoPassoContratacao } from "../../features/pages/seguro/passo-contracao";


const SeguroPage = () => {
    const _globalState = useHookstate(globalState);

    const stepperData: StepperData[] = [
        {
            label: "Seguro",
            contentComp: <PassoSeguro />,
            onEditClick: async () => await gotoPassoSeguro()
        },
        {
            label: "Contratação",
            contentComp: <PassoContratacao />,
            onEditClick: async () => await gotoPassoContratacao()
        }
    ]

    return (
        <>
        {
            _globalState.simulacao?.get() &&
            <>
                <AvisoMaisDeDoisSegurosAtivos />
                <PageRoot
                    leftPanel={{
                        content: <Stepper 
                            stepperData={stepperData} 
                            passoCorrente={_globalState.simulacao.passo.get()}
                            passoAlcancado={_globalState.simulacao.passoAlcancado.get()} />
                    }}
                    rightPanel={{
                        content: <SummaryBox />,
                        width: "25%"
                    }}
                />
            </>
        }
        </>
    );
}

export default SeguroPage;